import { render, staticRenderFns } from "./record.vue?vue&type=template&id=027bbe12&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=027bbe12&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027bbe12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027bbe12')) {
      api.createRecord('027bbe12', component.options)
    } else {
      api.reload('027bbe12', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=027bbe12&scoped=true", function () {
      api.rerender('027bbe12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/baseManagement/availabilityReport/record.vue"
export default component.exports